import { useOnline } from '@libs/hooks';
import { ConditionalRender } from '@libs/utils';
import React from 'react';
import { CommonScreen } from './CommonScreen/CommonScreen';
import { CrossRoundedIcon } from './utils/CrossRounded';

export const Offline = () => {
    const isOnline = useOnline();

    return (
        <ConditionalRender condition={!isOnline}>
            <CommonScreen color="#F1557F" Icon={CrossRoundedIcon} mainText="Network disconnected" />
        </ConditionalRender>
    );
};
